<template>
  <div class="actionPlan">
    <div class="show add">
      <div class="head">
        <img src="~@img/xueyezixun/public/showTitle.png" alt="">
        <p>{{data.gradeName}}-{{data.nameName}}-{{data.actionPlan==1&&'第一次'||data.actionPlan==2&&'第二次'||data.actionPlan==3&&'第三次'||data.actionPlan==4&&'第四次'}}行动计划</p>
      </div>
      <div>
        <MessageTitle title="阶段任务考试" style="font-weight: normal"></MessageTitle>
        <circleName :name="'本阶段考试:'+data.gradeData.gradeName+data.gradeData.nameName"></circleName>
        <table>
          <tbody>
          <tr>
            <th style="width: 240px">科目</th>
            <th v-for="(item,index) in data.subject||[]" :key="index">{{item.subject}}</th>
          </tr>
          <tr>
            <td style="width: 240px">学期目标分数</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.semesterTargetScore}}</td>
          </tr>
          <tr>
            <td style="width: 240px">学期名次目标</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.semesterRankingGoals}}</td>
          </tr>
          <tr>
            <td style="width: 240px">阶段分数目标</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.stageScoreGoal}}</td>
          </tr>
          <tr>
            <td style="width: 240px">阶段名次目标</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.stageRankingGoal}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ul class="showlist">
        <li v-for="(item,index) in data.subjectStress||[]" :key="index">
        <span>
          <img src="~@img/xueyezixun/public/star.png" alt="">
          {{item.subject}}
        </span>
          <div v-for="(it,i) in item.task" :key="i">
            <p>阶段问题{{it.length>1?i+1:''}}:{{it.stageProblem}}</p>
            <p>阶段任务{{it.length>1?i+1:''}}:{{it.stageTask}}</p>
          </div>
        </li>

      </ul>
      <ul class="showlist">
        <li v-for="(item,index) in data.subjectCommon||[]" :key="index">
        <span>
          <img src="~@img/xueyezixun/public/star.png" alt="">
          {{item.subject}}
        </span>
          <div v-for="(it,i) in item.task" :key="i">
            <p>阶段问题{{it.length>1?i+1:''}}:{{it.stageProblem}}</p>
            <p>阶段任务{{it.length>1?i+1:''}}:{{it.stageTask}}</p>
          </div>
        </li>
      </ul>
      <div>
        <MessageTitle title="学习习惯养成" style="font-weight: normal"></MessageTitle>
        <div class="habit">
          <table v-for="(item,index) in data.subjectLearnHabit||[]" :key="index">
            <tbody>
            <tr>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>阶段问题</td>
              <td>{{item.stageProblem}}</td>
            </tr>
            <tr>
              <td>目标习惯</td>
              <td>{{item.targetHabit}}</td>
            </tr>
            <tr>
              <td>行动方案</td>
              <td>{{item.actionPlan}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <MessageTitle title="路径条件" style="font-weight: normal"></MessageTitle>
        <circleName :name="'条件目标：'+data.consultRecord"></circleName>
        <div class="habit">
          <table v-for="(item,index) in data.subjectPathCondition||[]" :key="index">
            <tbody>
            <tr>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>阶段目标</td>
              <td>{{item.stageTarget}}</td>
            </tr>
            <tr>
              <td>阶段任务</td>
              <td>{{item.stageTask}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="bottom" style="width: 300px;margin: 40px auto;display: flex;justify-content: space-between">
        <Button name="返回修改"
                @handleClick="returns" :style="{borderRadius:'16px'}"></Button>
        <Button name="保存"   @handleClick="submit" :style="{borderRadius:'16px'}"></Button>
      </div>
    </div>
  </div>
</template>
<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetail'
export default {
  name: 'gradeDetail',
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail },
  data() {
    return {
      data:JSON.parse(window.sessionStorage.getItem('actionPreview'))
    }
  },
  methods: {
    returns(){
      this.$router.back()
    },
    //筛选科目
    screenSubject(name){
      if (name == '语文') {
        return 1
      }
      if (name == '数学') {
        return 2
      }
      if (name == '外语'|| name == '英语') {
        return 3
      }
      if (name == '物理') {
        return 4
      }
      if (name == '化学') {
        return 5
      }
      if (name == '生物') {
        return 6
      }
      if (name == '历史') {
        return 7
      }
      if (name == '地理') {
        return 8
      }
      if (name == '政治') {
        return 9
      }
      if (name == '技术') {
        return 10
      }
      return 0
    },
    submit(){
      const {studentId, gradeId, actionPlan, subject, consultRecord
        , interViewData, subjectStress, subjectCommon, subjectLearnHabit
        , subjectPathCondition ,gradeName, nameName} = this.data;
      let subjectStress_item=[],
          subjectCommon_item=[],
          _this=this;
      subjectStress.forEach(item=>{
        let subject =_this.screenSubject(item.subject)
        item.task.forEach(it=>{
          let object = {
            subject:subject,
            ...it
          }
          subjectStress_item.push(object)
        })
      })
      subjectCommon.forEach(item=>{
        let subject =_this.screenSubject(item.subject)
        item.task.forEach(it=>{
          let object = {
            subject:subject,
            ...it
          }
          subjectCommon_item.push(object)
        })
      })
      subjectLearnHabit.forEach(item=>{
        if(item.disabled){
          delete item.disabled
        }
      })
      for(let i=0;i<$('.addBox input[type=text]').length;i++){
        if(!$('.addBox input[type=text]')[i].value){
          this.$message.error("请将数据补充完整")
          return;
        }
      }

      if(!actionPlan||(!consultRecord)){
        this.$message.error("请将数据补充完整")
        return;
      }
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.add, {
        studentId:sessionStorage.getItem('myStudentStudentId'),
        studentTestScoreId:gradeId,
        actionPlan:actionPlan,
        subject:subject,
        consultRecord:consultRecord,
        interviewRecord:interViewData,
        subjectStress:subjectStress_item,
        subjectCommon:subjectCommon_item,
        subjectLearnHabit:subjectLearnHabit,
        subjectPathCondition:subjectPathCondition,
        semester:gradeName,
        monthly_exam:nameName
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let data=res.data;
          sessionStorage.removeItem('actionPreview')
          this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/show',
            query:{gradeId:this.gradeId,actionPlanId:data.data.id}})
        }else{

        }
      })
    },
  },
  mounted() {
  }
}
</script>
<style scoped lang="less">
th{
  font-weight: bolder;
  text-align: center;
  color:#5C5C5C;
}
@import "./css/index.less";
</style>